import React, { PropsWithChildren } from 'react';

import FirebaseProvider from 'Modules/firebase/FirebaseProvider';

const AuthWrapper: React.FC<PropsWithChildren> = ({ children }) => {
    return <FirebaseProvider>{children}</FirebaseProvider>;
};

export default AuthWrapper;
